import { useEffect } from 'react';
export default function DialogAccessibility() {
  useEffect(() => {
    let dialog: HTMLElement | null = null;
    let previous: HTMLElement | null = null;
    const focusable = (root: HTMLElement) => Array.from(root.querySelectorAll<HTMLElement>('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(element => element.getClientRects().length > 0);
    const currentDialog = () => { const dialogs = Array.from(document.querySelectorAll<HTMLElement>('[role="dialog"][aria-modal="true"]')).filter(element => element.getClientRects().length > 0); return dialogs[dialogs.length - 1] || null; };
    const sync = () => {
      const next = currentDialog();
      if (next === dialog) return;
      if (next) { if (!dialog) previous = document.activeElement as HTMLElement; dialog = next; (focusable(next)[0] || next).focus(); }
      else { dialog = null; if (previous?.isConnected) previous.focus(); previous = null; }
    };
    const keyboard = (event: KeyboardEvent) => {
      if (event.key !== 'Tab' || !dialog) return;
      const elements = focusable(dialog); if (!elements.length) { event.preventDefault(); return; }
      const first = elements[0], last = elements[elements.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    };
    const observer = new MutationObserver(sync); observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', keyboard); sync();
    return () => { observer.disconnect(); document.removeEventListener('keydown', keyboard); };
  }, []);
  return null;
}
